// Pending calibration-assignment count for the in-app badge (staff-tree only). The
// poller that drives it lives in the service. See CLAUDE.md store rule.
import { createStore } from './create-store';

const [usePendingCalibrationCount, , setPendingCalibrationCount] = createStore<number>(0);
export { usePendingCalibrationCount, setPendingCalibrationCount };
